























import {
  computed,
  defineComponent,
  ref,
  useStore,
} from '@nuxtjs/composition-api'
import TeleportV2 from '@/components/TeleportV2.vue'
import RgsModalAside from '@/components/RgsModalAside.vue'
import NavigationLayout from '@/components/Navigation/NavigationLayout.vue'
import RgsToggle from '@/components/RgsToggle.vue'

export default defineComponent({
  name: 'NavigationModal',
  components: { RgsToggle, NavigationLayout, RgsModalAside, TeleportV2 },
  setup() {
    const store = useStore()
    const isMobile = computed(() => store.getters['mediaQuery/isMobileMq'])
    const activeSectionId = ref(
      store.getters['settings/navigation'].children[0]?.id
    )
    const activeSection = computed(() =>
      store.getters['settings/navigation'].children.find(
        (child) => child.id === activeSectionId.value
      )
    )
    const toggleOptions = computed(() =>
      store.getters['settings/navigation'].children.map((child) => {
        return {
          id: child.id,
          value: child.code,
          label: child.name,
        }
      })
    )
    const setActiveSection = (id) => {
      activeSectionId.value = id
      store.commit('navigation/SET_IS_SUBPAGE_OPEN', null)
    }

    const onClose = () => {
      store.commit('navigation/SET_IS_SUBPAGE_OPEN', null)
      store.commit('modal/UNSET_MODAL')
    }

    const isVisible = computed(
      () => store.getters['modal/GET_MODAL'] === 'modal-navigation'
    )
    return {
      isVisible,
      activeSection,
      activeSectionId,
      toggleOptions,
      isMobile,
      setActiveSection,
      onClose,
    }
  },
})
